'use strict';

import React, { Component, useDebugValue } from 'react';
import { render } from 'react-dom';
import { AgGridReact } from '@ag-grid-community/react';
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { RowGroupingModule } from '@ag-grid-enterprise/row-grouping';
import { MenuModule } from '@ag-grid-enterprise/menu';
// import Consignmentforceclose from '../m';
import Select from 'react-select';
import DrawMap from '../common/drawmap';
import CommentActions from "../layouts/commentsComponent";
import ForceCloseSideBar from "./forceclosuresidebarcomponent";
import { AllModules, GridOptionsWrapper } from '@ag-grid-enterprise/all-modules';
import { ColumnsToolPanelModule } from '@ag-grid-enterprise/column-tool-panel';
import { FiltersToolPanelModule } from '@ag-grid-enterprise/filter-tool-panel';
import { SetFilterModule } from '@ag-grid-enterprise/set-filter';
import MarkDeliver from "../layouts/markDeliveredButton.js";
import '@ag-grid-community/core/dist/styles/ag-grid.css';
import "@ag-grid-enterprise/all-modules/dist/styles/ag-theme-balham.css";
import ConsignmentActions from '../manage/ConsignmentActionsComponent';
import CountUp from 'react-countup';
import SweetAlert from 'react-bootstrap-sweetalert';
import CSVFileValidator from 'csv-file-validator';
import Consignmentforceclose from '../manage/consignmentforceclose';
import UpdateButton from "./updatelmstates";
import * as Datetime from 'react-datetime';
import 'react-datetime/css/react-datetime.css';
import CellGraphComponent from './cellGraphComponent';
import $ from 'jquery';
import ColumnGroup from './columngroupComponent';
import { getDDMMYYYY, getHyphenYYYYMMDD,getHyphenDDMMMYYYYHHMM,getHyphenDDMMMYYYY,getHyphenYYYYMMDDHHMMSS,getHyphenDDMMYYYYHHMMSS,getDDMMYYYYHHMMSS, getYYYYMMDD, getYYYYMMDDHHMMSS } from '../common/utils'; 
import Highcharts from 'highcharts/highstock';
import HighchartsReact from 'highcharts-react-official';
import { HardwareDesktopWindows } from 'material-ui/svg-icons';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import interactionPlugin from '@fullcalendar/interaction'
import timeGridPlugin from "@fullcalendar/timegrid";
import download from 'js-file-download';
import { LoadingPortContext, resolvePageAccess } from '../../context/LoadingPortContext';
import SobRunPanel, { sobStatusBadge } from './sobRunPanel';

// const $ = window.$;
window.jQuery = $;
window.$ = $;
var redirectURL = require('../redirectURL');
var moment = require('moment');
var filecontent="";
var googleAnalytics = require("../common/googleanalytics");
var CELL_DIMENSION_SIZE = 90;




export default class LmLoadSummary extends Component {
  static contextType = LoadingPortContext;

  constructor(props, context) {
    super(props, context);
    this._lastLoadingPortCode = context ? context.loading_port_code : null;
      this.state = {
        modules : AllModules,
        defaultColDef: {
            sortable: true,
            filter: true,
            editable: true,
        },
        eventAction: null,
        show: false,
        frameworkComponents : {
          consignmentforceclose:Consignmentforceclose,
          consignmentActions:ConsignmentActions,
          UpdateButton:UpdateButton,
          MarkDeliver : MarkDeliver,
          commentActions : CommentActions
        },
        modified_by:"",
        basicTitle:'',
        reasonforceclose:"",
        bulkslide:"",
        file:"",
        uploadFile:"",
        basicType:"default",
        loadshow:'show-n',
        forceCloseRowNode : "",
        forceclosedata:"",
        csvcontent:"",
        sliderForceCloseTranslate:"",
        overly:'',
        rowData:[],
        bulkslide:"",
        showDiv:"",
        uploadDivWidth:"",
        mapinfo:"",
        dealer:"",
        sliderCommentTranslate:"",
        commentsRowData:"",
        consignment_code:"",
        sliderRouteTranslate:"",
        maptruckno:"",
        routeTruck:	"",
        rownode:"",
        googelRoutes:"",
        file:"",
        file1:"",
        rowSelection:'multiple',
        truckloadSelectedCount: 0,
        sliderForceCloseTranslate:"",
        maptruckno:"",
        rowModelhighchartoptionsType: 'enterprise',
        rowGroupPanelShow: 'always',
            statusBar: {
        statusPanels: [
          {
          statusPanel: "agTotalAndFilteredRowCountComponent",
          align: "left"
          },
          {
          statusPanel: "agTotalRowCountComponent",
          align: "center"
          },
          { statusPanel: "agFilteredRowCountComponent" },
          { statusPanel: "agSelectedRowCountComponent" },
          { statusPanel: "agAggregationComponent" }
        ]
            },
        paginationPageSize:200,
        geofencelist:[],
        geoFenceData:"",
        sideBar: {
          toolPanels: [
            {
            id: "columns",
            labelDefault: "Columns",
            labelKey: "columns",
            iconKey: "columns",
            toolPanel: "agColumnsToolPanel"
            },
            {
            id: "filters",
            labelDefault: "Filters",
            labelKey: "filters",
            iconKey: "filter",
            toolPanel: "agFiltersToolPanel"
            }
          ]
        },
        animateRows: true,
        dept_code:"",
        pagetitle:"",
        markDeliverRowNode : "",
        markDeliverData:"",
        sliderMarkDeliverTranslate:"",
        csvData:0,
        overly:"show-n",
        loadshow:"show-n",
        holidayEvents : [],
        showCalendar : "show-m",
        showGridData : "show-m",
        loadFile : "",
        processErrMsg : "",
        processErrShow : 0,
        transactionId : "",
        comp_code : "",
        lpNames : [],
        loading_port_code : "",
        bulkslide1:"",
        transaction:"",
        fileName:''
        //components : {datepicker:getDatePicker()}
    }
    this.changeFileHandler = this.changeFileHandler.bind(this);
    this.changeFileHandler1 = this.changeFileHandler1.bind(this);
    this.uploadBulkFormHandler = this.uploadBulkFormHandler.bind(this);
    this.uploadBulkFormHandler1 = this.uploadBulkFormHandler1.bind(this);
    this.gridRef = React.createRef();
    this.gridRefDropped = React.createRef();

}
componentDidMount(){
    this.pageAccess();
}
async pageAccess(){
    this.setState({
        loadshow:'show-m',
        overly:'show-m',
    })
    var currentUrl = this.props.match.path;
    try{
        var resolved = await resolvePageAccess(currentUrl, this.context);
        if (!resolved) {
            // No access (already alerted+redirected), empty port list, or a logged request error.
            this.setState({ loadshow: 'show-n', overly: 'show-n' });
            return;
        }
        this._lastLoadingPortCode = resolved.loading_port_code;
        this.setState({
            pageAccess: resolved.pageAccess,
            loading_port_code: resolved.loading_port_code,
            comp_code: resolved.comp_code,
            lpNames: resolved.lpNames,
            loadshow: 'show-n',
            overly: 'show-n',
        });
        await this.onLoadPageData();
    }
    catch(e){
        console.log(e,"lineno-333")
    }
}
onLoadPageData(){
    this.setState({
        overly:"show-m",
        loadshow:"show-m",
    })
    var loading_port_code = this.state.loading_port_code;
    var params = {
        loading_port_code : loading_port_code
    }
    redirectURL.post("/lmconsignees/getLoadProcessRunDetails",params).then((response)=>{
        console.log(response.data,"loadprocess");
        // Kept in whatever order the backend returns them - a just-saved approval
        // should stay right where the row already was, not jump to the top.
        this.setState({
            rowData : response.data || [],
            truckloadSelectedCount: 0,
            overly:"show-n",
            loadshow:"show-n",
        })
    }).catch((e)=>{
        console.log(e);
    })
}

showBulkUpload(){
    this.setState({
        overly :"show-m",
        bulkslide : "slider-translate"
    })
}
resetUpload = () => {
    this.setState({
        bulkslide:'',
        overly:'show-n',
        loadFile:''
    });
    $("#notify_email").val("");
}
fixProcess = () => {
    this.setState({
        processErrMsg : "",
        processErrShow : 0,
        loadFile:''
    });
    $("#notify_email").val("");
}
ignoreProcessError = () => {
    var transactionId = this.state.transactionId;
    console.log("transactionId",transactionId)
    var params = {
        transactionId : transactionId,
    }
    this.setState({
        loadshow:"show-m",
        overly:"show-m",
    });
    redirectURL.post("/lmconsignees/generateLoadByTransactionId",params).then((response)=>{
        //console.log(response.data,"response")
        var statusCode = response.data.status;
        if(statusCode == 0)
        {
            this.setState({
                basicTitle : response.data.message,
                basicType : "success",
                show : true,
                loadshow:"show-n",
                overly:"show-n",
            });
        }
        else
        {
            this.setState({
                processErrMsg : response.data.message,
                processErrShow : 1,
                transactionId : response.data.transactionId,
                loadshow:"show-n",
                overly:"show-n",
            });
        }
        //window.location.reload();
    }).catch((e)=>{
        console.log(e);
        this.setState({
            loadshow:"show-n",
            overly:"show-n",
        });
    });
}
changeFileHandler = async (e) => {
    console.log(e);
    this.setState({
        loadFile : e.target.files[0]
    });    
}
changeFileHandler1 = async (e) => {
    // console.log(e.target.files[0])
    var dt = '';
    // const config = {
    // 	headers: ["ticketNo", "communicationType", "status", "satisfactoryResponse", "comments", "pasteResponseEmail"]
    // }
    document.getElementById("inValidDataInfo").innerHTML = "";

    const config = {
        headers: [
            { 
                name: 'trip_no_system',
                inputName: 'trip_no_system',
                required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'vehicle_type_system',
                inputName: 'vehicle_type_system',
                required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'loading_sequence_system',
                inputName: 'loading_sequence_system',
                required: true,
                validate: function(no) {
                    return isNoValid(no)
                },
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is out of range(1-10) in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'consignee_code',
                inputName: 'dealer_code',
                required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'pick_ticket',
                inputName: 'pick_ticket',
                // required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'transporter_name_system',
                inputName: 'transporter_name_system',
                // required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'trip_no_manual',
                inputName: 'trip_no_manual',
                required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'vehicle_type_manual',
                inputName: 'vehicle_type_manual',
                required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'loading_sequence_manual',
                inputName: 'loading_sequence_manual',
                required: true,
                validate: function(no) {
                    return isNoValid(no)
                },
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is out of range(1-10) in the ${rowNumber} row / ${columnNumber} column`
                }
            },
            { 
                name: 'transporter_name_manual',
                inputName: 'transporter_name_manual',
                // required: true,
                requiredError: function (headerName, rowNumber, columnNumber) {
                    return `${headerName} is required in the ${rowNumber} row / ${columnNumber} column`
                }
            }
            
        ]
    }
    CSVFileValidator(e.target.files[0], config)
    .then(async(csvData) => {
        // console.log(csvData.data,'csvData.data')
        await this.setState({
            csvcontent:csvData.data
        });
        document.getElementById("inValidDataInfo").innerHTML = "";
            if (csvData.inValidMessages.length > 0) {
              $("#uploadFile1").val("");
              document.getElementById("bulkUploadBtn").type = "button";
              document
                .getElementById("bulkUploadBtn")
                .classList.remove("btn-success");
              document
                .getElementById("bulkUploadBtn")
                .classList.add("btn-secondary");
              let invalidData = csvData.inValidMessages;
              let element = document.getElementById("inValidDataInfo");
              invalidData.map((item) => {
                
                element.innerHTML +=
                
                  "--" +
                  item +
                  "<br></br>";
              });
            } else {
                document.getElementById("bulkUploadBtn").type = "submit";
                document
                  .getElementById("bulkUploadBtn")
                  .classList.remove("btn-secondary");
                document
                  .getElementById("bulkUploadBtn")
                  .classList.add("btn-success");
              }
    })
    .catch(err => {})
        
    // var out = new Promise(function(reject, resolve){
    //     var reader =  new FileReader();
    //     reader.onload = async function(e) {
    //         var contents = await e.target.result;
    //         console.log("contents ", contents )
            
    //         resolve(contents);
    //     };
    //     var tt =  reader.readAsText(e.target.files[0]);
    //     console.log("tt ",tt)
    // });
    //console.log("Out ", out);
    
    // this.setState({
    //     file1:e.target.files[0]
    // });
    
}

uploadBulkFormHandler(event){
    event.preventDefault();
    var flag = 0;
    let saveData = new FormData();
    if(flag == 0)
    {      
        saveData.append("loadFile", this.state.loadFile);
        var notify_email = $("#notify_email").val();
        saveData.append("notify_email", notify_email);
        var loading_port_code = this.state.loading_port_code;
        saveData.append("loading_port_code", loading_port_code)
        redirectURL.post("/lmconsignees/generateLoad",saveData).then((response)=>{
            console.log(response.data,"response")
            var statusCode = response.data.statusCode;
            if(statusCode == 0)
            {
                this.setState({
                    basicTitle : response.data.message,
                    basicType : "success",
                    show : true,
                });
            }
            else
            {
                this.setState({
                    processErrMsg : response.data.message,
                    processErrShow : 1,
                    transactionId : response.data.transactionId,
                });
            }
            //window.location.reload();
        })
        .catch((e)=>{
            console.log(e,"uploadBulkFormHandler");
            this.setState({
                basicTitle : "Error in uploading file",
                basicType : "error",
                show : true,
            });
        })
    }
    else
    {
        this.setState({
            basicTitle : "Please upload the file",
            basicType : "warning",
            show : true,
        })
    }
};
uploadBulkFormHandler1 = (event)=>{
    event.preventDefault()
    this.setState({
        loadshow:"show-n",
        overly:"show-m"
    })
    // console.log("changes")
    var csvData = this.state.csvcontent
    var transaction_id = this.state.transaction
    var file_name=this.state.fileName
    var loading_port_code = this.state.loading_port_code;
    // console.log(csvData,transaction_id,"593",loading_port_code)
    var params = {
        csvData : csvData,
        transaction_id : transaction_id,
        file_name : file_name,
        loading_port_code : loading_port_code
    }

    redirectURL
        .post("/lmconsignees/validateInputPlanData", params)
        .then((response) => {
          var newStatusCode = response.data.status;
    
    if(newStatusCode == 1){
    

    redirectURL.post("/lmconsignees/bulkUploadsystemvsmanualdata",params).then((response)=>{
        if(response.data.message == "Success"){
            this.setState({
                loadshow:"show-n",
                overly:"show-n",
                bulkslide1:"",
                basicTitle:"Data Successfully Updated",
                basicType:"success",
                show:true
            })
            $("#uploadFile1").val("")
            this.onLoadPageData()

        redirectURL.post("/lmconsignees/triggerScriptForInputPlanData", params)
        }
        else if(response.data.message == "Please Upload Complete Data"){
            this.setState({
                loadshow:"show-n",
                overly:"show-n",
                bulkslide1:"",
                basicTitle:"Please Upload Complete Data",
                basicType:"warning",
                show:true
            })
            $("#uploadFile1").val("")
            this.onLoadPageData()
        }
        else{
            this.setState({
                loadshow:"show-n",
                overly:"show-n",
                bulkslide1:"",
                basicTitle:"Data Not Updated",
                basicType:"warning",
                show:true
            })
            $("#uploadFile1").val("")
            this.onLoadPageData()
        }
    })
    
    }else{
        if (newStatusCode == 8) {
            this.setState({
              processErrMsg: response.data.message,
              processErrShow: 1,
              droppedList: response.data.droppedList,
              loadshow: "show-n",
              overly: "show-n",
            });
            $("#uploadFile1").val("")
          }
    }
    })

} 
onGridReady = params => {
    this.gridApi = params.api;
    //console.log("Grid is: ", params);
    this.gridColumnApi = params.columnApi;
};
// Pre-checks rows already truckload_approved:true so the checkbox column reflects
// saved state, not just this session's pending selection.
onFirstDataRendered = params => {
    params.api.forEachNode(function (node) {
        if (node.data && node.data.truckload_approved) {
            node.setSelected(true);
        }
    });
};
// "Save Approvals" only ever appears once something is checked, and only ever sets
// approved:true for the checked transaction_ids - it never unapproves anything, so
// unchecking an already-approved row (just to look at the grid) can't accidentally
// revoke it. Already-approved rows are pre-checked (onFirstDataRendered) purely to
// show their saved state - they're excluded from this count so the button doesn't
// reappear just because approved rows exist; only a genuinely new, pending
// selection should show it.
onSelectionChanged = () => {
    var selected = this.gridApi ? this.gridApi.getSelectedRows() : [];
    var pendingCount = selected.filter(function (r) { return !r.truckload_approved; }).length;
    this.setState({ truckloadSelectedCount: pendingCount });
};
saveTruckloadApprovals = () => {
    if (!this.gridApi) return;
    var selectedIds = this.gridApi.getSelectedRows().map(function (r) { return r.transaction_id; });
    if (selectedIds.length === 0) return;
    var identity = {
        user_name: localStorage.getItem('username'),
        staff_id: localStorage.getItem('staff_id'),
        email: localStorage.getItem('email')
    };
    redirectURL.post("/lmconsignees/setTruckloadApproval", Object.assign({ transaction_ids: selectedIds, approved: true }, identity)).then(() => {
        this.setState({ show: true, basicType: "success", basicTitle: "Approvals saved" });
        this.onLoadPageData();
    }).catch((e) => {
        console.log(e);
        this.setState({ show: true, basicType: "danger", basicTitle: "Failed to save approvals" });
    });
};
onGridState = () =>{
    //console.log(this.gridApi);

    /*Get  Current Columns State and Store in this.colState */
    this.colState = this.gridColumnApi.getColumnState();

    /*Get Current RowGroup Columns State and Store in this.rowGroupState */
    this.rowGroupState = this.gridColumnApi.getRowGroupColumns();

    /*Get Current Pivot Columns State and Store in this.pivotColumns, 
    * User should enable the Pivot mode.*/
    this.pivotColumns = this.gridColumnApi.getPivotColumns();
            
    /*Get Current Filter State and Store in window.filterState */
    window.filterState = this.gridApi.getFilterModel();
    this.gridApi.setFilterModel(window.filterState);
}



closeAlert = () => {
    this.setState({
        show: false
    });
}

onCellClickedGrid(e)
{
    var clicked = e.event && e.event.target && e.event.target.closest ? e.event.target.closest("[data-action]") : null;
    var action = clicked ? clicked.getAttribute("data-action") : "";
    if(action == "sob" && e.data && [1,2,3].indexOf(parseInt(e.data.data_processed)) >= 0)
    {
        this.setState({ sobPanel: { open: true, transactionId: e.data.transaction_id,
                                     loadingPortCode: e.data.loading_port_code, dataType: e.data.data_type } });
        return;
    }
    
    if(action == "download")
    {
        this.setState({
            loadshow: "show-m",
            overly: "show-m"
        });
        var inputFile = e.data.filename;

        // console.log(inputFile,'sai kumar')
        if(inputFile !='')
        {
            let transactionId = e.data.transaction_id;
            let plantCode = e.data.loading_port_code;
            var rngParam = {
                inputFile : inputFile,
                transactionId: transactionId,
                plantCode: plantCode,
            }
            redirectURL.post("/lmconsignees/downloadInputFile",rngParam).then((response)=>{
                // console.log("download response ",response)
                // download(response.data, inputFile)
                // if(response.data.message == "success")
                // {
                //     alert("success");
                // }
                // Create a new Blob object using the response data
                const blob = new Blob([response.data], { type: 'text/csv' });
        
                // Create a link element, use it to download the blob, and remove it
                const link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = inputFile;
                document.body.appendChild(link);
                link.click();
        
                // Clean up and revoke the URL
                window.URL.revokeObjectURL(link.href);
                document.body.removeChild(link);
                this.setState({
                    loadshow: "show-n",
                    overly: "show-n"
                });
                console.log("File download should have started.");
            }).catch(function(error){
                console.log(error);
                this.setState({
                    loadshow: "show-n",
                    overly: "show-n"
                });
            })
        }
    }
    if(e.colDef.field == "upload_file")
    {
        var transactionId = e.data.transaction_id
        var file_name = e.data.filename

        console.log(e.data,"check")
        this.setState({
            bulkslide1:"slider-translate-30p",
            overly:"show-m",
            transaction:transactionId,
            fileName : file_name
        })
    }
}

onClickHideAll(){
    this.setState({
    loadshow:'show-n',
    overly:'show-n',
    bulkslide:"",
    bulkslide1:"",
    });
    $("#uploadFile1").val("")
    document.getElementById("inValidDataInfo").innerHTML = "";
}
showGrid(){
    this.setState({
        showCalendar : "show-n",
        showGridData  : "show-m"
    })
}
componentDidUpdate() {
    if (this.context && this.context.loading_port_code !== this._lastLoadingPortCode) {
        this._lastLoadingPortCode = this.context.loading_port_code;
        this.onGlobalPortChange();
    }
}
onGlobalPortChange = async () => {
    var selectedPlant = this.context.loading_port_code;
    if (!selectedPlant || !this.state.lpNames.some(each => each.loading_port_code == selectedPlant)) {
        // Not a valid port for this screen - keep this screen's own selection, don't refetch.
        return;
    }
    await this.pageAccess();
}

dataDiscrepency = () => {
    this.setState({
      processErrMsg: "",
      processErrShow: 0,
      csvcontent: "",
    });
    $("#uploadFile1").val("");
    //document.getElementById("upform").reset();
  };

  hideSlideBlock = () =>{
    this.setState({
    loadshow:'show-n',
    overly:'show-n',
    bulkslide:"",
    bulkslide1:"",
    });
    $("#uploadFile1").val("")
    document.getElementById("inValidDataInfo").innerHTML = "";
}

  render() {
    var showActions = false;
    var showDelete = true;
    if(this.state.pageAccess == 2)
    {
        var showActions = true;
    }
    if(this.state.pageAccess == 3)
    {
        var showDelete = false;
    }
    // Same "is this transaction actually processed" check the Details column uses to
    // decide View vs N/A - a transaction still processing (or errored) has nothing
    // to approve yet, so it gets no checkbox at all rather than a disabled one.
    var isTransactionProcessed = function (data) {
        return data && (data.data_processed == 1 || data.data_processed == 2 || data.data_processed == 3);
    };
    // Layout (client, 2026-10-09): actions + SOB status pinned LEFT so they never scroll away,
    // input download is a small icon, File Name moved to the far right, widths tightened.
    var centerCell = { textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center" };
    var columnwithDefs = [
        {
            headerName: "",
            field: "truckload_approve_select",
            width:40,
            checkboxSelection: (params) => isTransactionProcessed(params.data),
            headerCheckboxSelection: true,
            headerCheckboxSelectionFilteredOnly: true,
            filter: false,
            resizable: false,
            editable:false,
            suppressMenu: true,
            pinned: 'left'
        },
        {
            // Actions as icons (client, 2026-10-09): view plan | SOB | download input. Each icon carries
            // data-action, which onCellClickedGrid reads to tell them apart (View is a plain link).
            pinned:"left",
            headerName: "Actions",
            colId: "row_actions",
            field: "transaction_id",
            width:96,
            filter: false,
            sortable: false,
            resizable: false,
            editable:false,
            suppressMenu: true,
            cellStyle: centerCell,
            cellRenderer:function(params){
                var d = params.data;
                var done = d.data_processed == 1 || d.data_processed == 2 || d.data_processed == 3;
                var icon = 'font-size:17px;margin:0 5px;';
                var off = icon + 'color:#c5cdd5;cursor:not-allowed;';
                var html = '';
                if(done) {
                    html += '<a href="/viewLoadSummaryDetails/' + window.btoa(d.transaction_id) + '" title="View plan" style="' + icon + 'color:#2c5aa0;"><i class="icofont icofont-eye-alt"></i></a>';
                    var runnable = d.sob_runnable_today;
                    var sobTitle = runnable ? ((d.sob_status_display && d.sob_status_display != 'NOT_RUN') ? 'Re-run SOB (only waiting trips)' : 'Run SOB') : 'View SOB result';
                    html += '<i data-action="sob" class="icofont icofont-truck-loaded" title="' + sobTitle + '" style="' + icon + 'cursor:pointer;color:' + (runnable ? '#2e7d32' : '#2c5aa0') + ';"></i>';
                } else {
                    html += '<i class="icofont icofont-eye-alt" title="Plan not completed" style="' + off + '"></i>';
                    html += '<i class="icofont icofont-truck-loaded" title="Plan not completed" style="' + off + '"></i>';
                }
                if(d.filename) {
                    html += '<i data-action="download" class="icofont icofont-download" title="Download input: ' + String(d.filename).replace(/"/g, '') + '" style="' + icon + 'cursor:pointer;color:#2c5aa0;"></i>';
                }
                return html;
            }
        },
        {
            headerName: "Generated On",
            field: "createDate",
            width:140,
            filter: true,
            resizable: true,
            editable:false,
            valueGetter:function(params){
                if(params.data.createdon != ''){
                return getHyphenDDMMMYYYYHHMM(params.data.createDate);
                }
                else{
                return "";
                }
            },
        },
        {
            headerName: "Transaction ID",
            field: "transaction_id",
            width:215,
            filter: true,
            resizable: true,
            editable:false
        },
        {
            headerName: "Load Type",
            field: "data_type",
            width:100,
            filter: true,
            resizable: true,
            editable:false,
            valueGetter:function(params){
                if(params.data.data_type == 1)
                {
                    return "Regular";
                }
                else if(params.data.data_type == 2)
                {
                    return "Courier";
                }
                else
                {
                    return "Dedicated";
                }
            }
        },
        {
            headerName: "Planning Mode",
            field: "is_automated",
            width:128,
            filter: true,
            resizable: true,
            editable:false,
            cellStyle: centerCell,
            valueGetter:function(params){
                if(params.data.is_automated && params.data.is_vip_check)
                {
                    return "Automated + VIP";
                }
                else if(params.data.is_automated)
                {
                    return "Automated";
                }
                else if(params.data.is_hub_hold)
                {
                    return "Regular + Hub Hold";
                }
                else if(params.data.is_vip_check)
                {
                    return "VIP Planning";
                }
                else
                {
                    return "Manual";
                }
            },
            cellRenderer:function(params){
                var badgeStyles = {
                    "Automated + VIP": "background-color:#673ab7;color:#ffffff;",
                    "Automated": "background-color:#1976d2;color:#ffffff;",
                    "Regular + Hub Hold": "background-color:#f9a825;color:#ffffff;",
                    "VIP Planning": "background-color:#e67e22;color:#ffffff;",
                    "Manual": "background-color:#607d8b;color:#ffffff;"
                };
                var style = badgeStyles[params.value] || badgeStyles["Manual"];
                return '<span style="'+style+'padding:0 8px;font-size:10.5px;line-height:18px;border-radius:9px;display:inline-block;white-space:nowrap;">'+params.value+'</span>';
            }
        },
        {
            headerName: "Status",
            field: "data_processed",
            width:200,
            filter: true,
            resizable: true,
            editable:false,
            cellStyle: { display: "flex", alignItems: "center" },
            tooltipValueGetter:function(params){ return params.value || ""; },
            // Coloured like SOB Status: green = completed, blue = processing, amber = invalid
            // input (fix and re-upload), red = run failed. Full text on hover.
            cellRenderer:function(params){
                var code = parseInt(params.data.data_processed);
                var bg = "#c62828";
                if([1, 2, 3].indexOf(code) >= 0) { bg = "#2e7d32"; }
                else if(code == 0 || code == 15) { bg = "#1976d2"; }
                else if([7, 8, 11].indexOf(code) >= 0) { bg = "#ef6c00"; }
                if(!params.value) { return ""; }
                return '<span style="background-color:' + bg + ';color:#fff;padding:0 8px;font-size:10.5px;line-height:18px;' +
                    'border-radius:9px;display:inline-block;white-space:nowrap;max-width:100%;overflow:hidden;text-overflow:ellipsis;">' +
                    params.value + '</span>';
            },
            valueGetter:function(params){
                if(params.data.data_processed == 0)
                {
                    return "Processing";
                }
                else if(params.data.data_processed == 1)
                {
                    // return "SOLVER_COMPLETE";
                    // SOB has its own column now - this is the PLAN's status only.
                    return "Plan processing completed";
                }
                else if(params.data.data_processed == 2)
                {
                    return "SOLVER_RECO_PROCESSED";
                }
                else if(params.data.data_processed == 3)
                {
                    // return "SOLVER_SOB_DONE";
                    // Plans SOB'd before the separate SOB status existed; their SOB column reads Completed.
                    return "Plan processing completed";
                }
                else if(params.data.data_processed == 4)
                {
                    return "SOLVER_INVALID_INPUT_FILE_NAME";
                }
                else if(params.data.data_processed == 5)
                {
                    return "SOLVER_NO_ASSIGNMENT_FILE";
                }
                else if(params.data.data_processed == 6)
                {
                    return "SOLVER_INVALID_CPP_EXE_FILE";
                }
                else if(params.data.data_processed == 7)
                {
                    return "Invalid Input Data : Dealers Dropped";
                }
                else if(params.data.data_processed == 8)
                {
                    // return "SOLVER_FIX_DROPED_DEALERS";
                    return "Invalid Input Data : Dealers Dropped";

                }
                else if(params.data.data_processed == 9)
                {
                    return "SOLVER_VEHICLE_DETAILS_MISSING";
                }
                else if(params.data.data_processed == 10)
                {
                    return "SOLVER_INPUT_FILE_DATA_ERROR";
                }
                else if(params.data.data_processed == 11)
                {
                    // return "SOLVER_INVALID_FILE_TEMPLATE";
                    return "Invalid File Uploaded";
                }
                else if(params.data.data_processed == 12)
                {
                    // return "PROCESS_TIMED_OUT";
                    return "Plan run unsuccessful";
                }
                else if(params.data.data_processed == 15)
                {
                    return "File is processing";
                }
            }
        },
        {
            // SOB status is separate from the plan status (client, 2026-10-08): a failed SOB no
            // longer hides the plan. Derived by Node (sob_status_display) incl. legacy plans.
            headerName: "SOB Status",
            field: "sob_status_display",
            width:118,
            filter: true,
            resizable: true,
            editable:false,
            cellStyle: centerCell,
            valueGetter:function(params){
                var labels = {"COMPLETED":"Completed","PARTIAL":"Partially allocated","IN_PROGRESS":"In progress","FAILED":"Failed","NOT_RUN":"Not run"};
                return labels[params.data.sob_status_display] || "Not run";
            },
            tooltipValueGetter:function(params){ return params.data.sob_remarks || ""; },
            cellRenderer:function(params){
                return sobStatusBadge(params.data.sob_status_display || "NOT_RUN", true);
            }
        },
        {
            headerName: "Approved",
            field: "truckload_approved",
            // 125 keeps the upper-case, letter-spaced header on one line (it wrapped at 88 and 108).
            width:125,
            filter: true,
            resizable: true,
            editable:false,
            cellStyle: centerCell,
            // Value stays Yes/No so the column filter and CSV export keep working; shown as an icon.
            valueGetter: (params) => (params.data.truckload_approved ? "Yes" : "No"),
            tooltipValueGetter: (params) => (params.data.truckload_approved ? "Plan approved" : "Not approved"),
            cellRenderer: (params) => {
                var approved = !!params.data.truckload_approved;
                return '<i class="icofont ' + (approved ? 'icofont-check-circled' : 'icofont-minus-circle') +
                    '" style="font-size:17px;color:' + (approved ? '#2e7d32' : '#b0bec5') + ';"></i>';
            }
        },
        {
            headerName: "Run BY",
            field: "user_email",
            width:200,
            filter: true,
            resizable: true,
            editable:false,
            hide: true
        },
        {
            headerName: "File Name",
            colId: "file_name_text",
            field: "filename",
            width:230,
            filter: true,
            resizable: true,
            editable:false,
            tooltipField: "filename"
        }
    ]

    var columnwithDefsForDropped = [
        {
          headerName: "Row No",
          field: "row",
          width: 70,
          filter: true,
          resizable: true,
          editable: false,
        },
        {
          headerName: "Column Name",
          field: "col",
          width: 100,
          filter: true,
          resizable: true,
          editable: false,
        },
        {
          headerName: "Remarks",
          field: "remarks",
          width: 200,
          filter: true,
          resizable: true,
          editable: false,
        //   cellRenderer: params => {
        //     if (params.value === null || params.value === undefined) {
        //       return 'Dealer Details Not Found'; 
        //     } else {
        //       return params.value;
        //     }
        //   },
        },
      ];


    return (
      <div class="container-fluid" style={{height: "100%"}}>
        <SweetAlert
            show={this.state.show}
            type={this.state.basicType}
            title={this.state.basicTitle}
            onConfirm={this.closeAlert}
        >
        </SweetAlert>

        <div className="card col-xl-12" style={{ borderRadius: "10px", boxShadow: "0 1px 4px rgba(0,0,0,0.08)", height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
            <div className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap", gap: "10px", padding: "14px 18px", marginBottom: "10px", flexShrink: 0 }}>
                <div className="d-flex align-items-center" style={{ gap: "14px" }}>
                    <div style={{ width: "5px", height: "26px", background: "linear-gradient(180deg,#1976d2,#42a5f5)", borderRadius: "3px", flexShrink: 0 }}></div>
                    <h5 style={{ margin: 0, fontSize: "16px", fontWeight: 700, color: "#1a237e", letterSpacing: "0.2px" }}>Load Summary</h5>
                </div>
                <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "8px" }}>
                    {(this.state.truckloadSelectedCount > 0) ?
                    <button type="button" className="pill-btn" style={{ background: "#2e7d32", color: "#fff", border: "none" }} onClick={this.saveTruckloadApprovals}>Save Approvals</button>
                    : ""}
                    {(this.state.pageAccess != 2) ?
                    <a href="/lmloadmanager" className="pill-btn pill-btn-info">Plan New Dispatch</a>
                    : ""}
                </div>
            </div>
            {/* Legend for the Actions icons (hover any icon for the same text) */}
            <div className="d-flex align-items-center" style={{ flexWrap: "wrap", gap: "16px", padding: "0 18px 8px", fontSize: "12px", color: "#546e7a", flexShrink: 0 }}>
                <span style={{ fontWeight: 700, color: "#37474f" }}>Actions:</span>
                <span><i className="icofont icofont-eye-alt" style={{ fontSize: "15px", color: "#2c5aa0", marginRight: "4px" }}></i>View plan</span>
                <span><i className="icofont icofont-truck-loaded" style={{ fontSize: "15px", color: "#2e7d32", marginRight: "4px" }}></i>Run / Re-run SOB (today's plans)</span>
                <span><i className="icofont icofont-truck-loaded" style={{ fontSize: "15px", color: "#2c5aa0", marginRight: "4px" }}></i>View SOB result</span>
                <span><i className="icofont icofont-download" style={{ fontSize: "15px", color: "#2c5aa0", marginRight: "4px" }}></i>Download input file</span>
                <span><i className="icofont icofont-eye-alt" style={{ fontSize: "15px", color: "#c5cdd5", marginRight: "4px" }}></i>Greyed out = plan not completed</span>
                <span style={{ fontWeight: 700, color: "#37474f", marginLeft: "8px" }}>Approved:</span>
                <span><i className="icofont icofont-check-circled" style={{ fontSize: "15px", color: "#2e7d32", marginRight: "4px" }}></i>Yes</span>
                <span><i className="icofont icofont-minus-circle" style={{ fontSize: "15px", color: "#b0bec5", marginRight: "4px" }}></i>No</span>
            </div>
            <div className="col-xl-12 col-lg-12" style={{ flex: 1, width: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
                <div className="ag-theme-balham grid-wrapper mb-3" style={{ flex: 1, minHeight: 0 }}>
                <AgGridReact
                    ref={this.gridRef}
                    modules={this.state.modules}
                    columnDefs={columnwithDefs}
                    rowData={this.state.rowData}
                    defaultColDef={{
                        sortable: true,
                        filter: true,
                        floatingFilter: true,
                        resizable: true
                    }}
                    isRowSelectable={(node) => isTransactionProcessed(node.data) && !(node.data && node.data.truckload_approved)}
                    getRowStyle={(params) => params.data && params.data.truckload_approved ? { background: "#e8f5e9" } : null}
                    statusBar={{
                        statusPanels: [
                            { statusPanel: "agSelectedRowCountComponent", align: "left" },
                            { statusPanel: "agFilteredRowCountComponent", align: "center" },
                            { statusPanel: "agTotalRowCountComponent", align: "right" }
                        ]
                    }}
                    sideBar={{
                        toolPanels: [
                            { id: 'columns', labelDefault: 'Columns', iconKey: 'columns', toolPanel: 'agColumnsToolPanel' },
                            { id: 'filters', labelDefault: 'Filters', iconKey: 'filter', toolPanel: 'agFiltersToolPanel' }
                        ]
                    }}
                    animateRows
                    rowHeight={45}
                    headerHeight={45}
                    onGridReady={this.onGridReady}
                    onFirstDataRendered={this.onFirstDataRendered}
                    onSelectionChanged={this.onSelectionChanged}
                    onCellClicked={this.onCellClickedGrid.bind(this)}
                    rowSelection={this.state.rowSelection}
                    suppressRowClickSelection={true}
                    />
            </div>
            </div>
        </div>
        <SobRunPanel
            open={!!(this.state.sobPanel && this.state.sobPanel.open)}
            transactionId={this.state.sobPanel ? this.state.sobPanel.transactionId : ""}
            loadingPortCode={this.state.sobPanel ? this.state.sobPanel.loadingPortCode : ""}
            dataType={this.state.sobPanel ? this.state.sobPanel.dataType : 1}
            onClose={() => this.setState({ sobPanel: null })}
            onDone={() => this.onLoadPageData()}
        />
        <div className={`hub-slider ${this.state.bulkslide ? "open" : ""} d-flex flex-column`}>

            <div className="slider-header">
                Imports Orders Data
                <span onClick={this.onClickHideAll.bind(this)} style={{ cursor: "pointer" }}>✕</span>
            </div>

            <div className="slider-body flex-grow-1" style={{ minHeight: "0px" }}>
                {this.state.processErrShow == 0 ?
                    <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadBulkFormHandler}>

                    <label className="m-0">Upload File<span className="text-danger">*</span></label>
                    <input type="file" name="uploadFile" id="uploadFile" onChange={this.changeFileHandler} className="mb-2" style={{ width: "100%" }} required />

                    <label className="m-0">Notify Email Users After Process (comma seperated)</label>
                    <textarea name="notify_email" id="notify_email" className="form-control mb-3"></textarea>

                    <div className="d-flex" style={{ gap: "8px" }}>
                        <button type="submit" className="pill-btn pill-btn-success">Generate Load</button>
                        <button type="button" onClick={this.resetUpload.bind(this)} className="pill-btn" style={{ backgroundColor: "#eceff1", color: "#455a64" }}>Cancel</button>
                    </div>
                    </form>
                :
                <div className="" style={{marginTop:"1em"}}>
                    <p style={{marginBottom:"1em"}}>{this.state.processErrMsg}</p>
                    <div className="d-flex" style={{ gap: "8px" }}>
                        <button type="button" onClick={this.fixProcess.bind(this)} className="pill-btn pill-btn-success">Fix and Reupload</button>
                        <button type="button" onClick={this.ignoreProcessError.bind(this)} className="pill-btn" style={{ backgroundColor: "#eceff1", color: "#455a64" }}>Ignore</button>
                    </div>
                </div>
                }
            </div>
        </div>
        <div className={`hub-slider ${this.state.bulkslide1 ? "open" : ""} d-flex flex-column`}>

            <div className="slider-header">
                Upload System V/S Manual Plan Data
                <span onClick={this.hideSlideBlock.bind(this)} style={{ cursor: "pointer" }}>✕</span>
            </div>

            <div className="slider-body flex-grow-1" style={{ minHeight: "0px" }}>
                {this.state.processErrShow == 0 ?
                    <form method="POST" id="upform" className="theme-form" onSubmit={this.uploadBulkFormHandler1}>

                    <label className="m-0">Upload File<span className="text-danger">*</span></label>
                    <input type="file" name="uploadFile1" id="uploadFile1" onChange={this.changeFileHandler1} className="mb-3" style={{ width: "100%" }} required />

                    <div className="d-flex mb-3" style={{ gap: "8px" }}>
                        <button type="submit" id="bulkUploadBtn" className="pill-btn pill-btn-success">Submit</button>
                        <button
                            type="button"
                            className="pill-btn pill-btn-danger"
                            onClick={this.hideSlideBlock.bind(this)}
                        >
                            Cancel
                        </button>
                    </div>
                    <div className="d-flex" style={{ gap: "8px" }}>
                        <a className="pill-btn pill-btn-primary" href={require('../../assets/json/system_vs_manual_bulkupload.csv')} target="_blank">Sample Template</a>
                        <a className="pill-btn" style={{ backgroundColor: "#eceff1", color: "#455a64" }} href={require('../../assets/pdf/Adherence_Documentation.pdf')} target="_blank">Download Guide</a>
                    </div>
                    <div id="inValidDataInfo" style={{ color: "red" }}></div>
                    </form>
                :
                <div className="" style={{marginTop:"1em"}}>
                    <p style={{marginBottom:"1em"}}>{this.state.processErrMsg}</p>
                    {this.state.droppedList.length > 0 ? (
                        <div
                        className="ag-theme-balham grid-wrapper"
                        style={{
                            width: "100%",
                            height: "300px",
                            marginBottom: "1em",
                        }}
                        >
                        <AgGridReact
                            ref={this.gridRefDropped}
                            modules={this.state.modules}
                            columnDefs={columnwithDefsForDropped}
                            rowData={this.state.droppedList}
                            defaultColDef={{
                                sortable: true,
                                filter: true,
                                floatingFilter: true,
                                resizable: true
                            }}
                            statusBar={{
                                statusPanels: [
                                    { statusPanel: "agFilteredRowCountComponent", align: "center" },
                                    { statusPanel: "agTotalRowCountComponent", align: "right" }
                                ]
                            }}
                            animateRows
                            rowHeight={45}
                            headerHeight={45}
                        />
                        </div>
                    ) : (
                        ""
                    )}
                    <button type="button" onClick={this.dataDiscrepency} className="pill-btn pill-btn-success">Fix and Reupload</button>
                </div>
                }
            </div>
        </div>
        <div className={"dataLoadpage " +(this.state.loadshow)} style={{zIndex:1100}}>
        </div>
        <div className={"dataLoadpageimg " +(this.state.loadshow)}>
            <div className="loader-box"><div className="loader-box"><div className="rotate dashed colored"></div></div></div>
        </div>
        <div
            className={"overlay-part "+(this.state.overly)}
            style={{zIndex:1100}}
            onClick={this.state.loadshow === "show-m" ? undefined : this.onClickHideAll.bind(this)}
        ></div>
        </div>

    );
  }
}

function isNoValid(no) {
    return no >= 1 && no <= 10;
}